import Seo from '../../components/Seo/Seo';
import Gjkereso from '../../components/Gjkereso/Gjkereso';
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';

const SERVICES = [
	{ h: 'Az év minden napján segítünk', p: 'Az év minden napján, hétvégéken, ünnepnapokon, mindig reggel 8 és éjfél között állunk rendelkezésére. Ez időben bármikor fogadjuk hívását és legtöbbször azonnal ki tudunk küldeni egy akku szerelőt.' },
	{ h: 'Budapesten a leggyorsabban', p: 'Budapest összes kerületében szerelünk, szezonon kívül általában a rendelés feladásakor azonnal indulunk és fél-egy órán belül megkezdjük a szerelést. A gyorsaságunk érdekében a város határait nem hagyjuk le.' },
	{ h: 'Márka-szervíz szintű szaktudás', p: 'A márka-szervízeknek megfelelő szintű szaktudással és speciális szerszámok segítségével a lehető leggyorsabban és legkényelmesebben cserélünk akkumulátort.' },
	{ h: 'Átlátható költségek', p: 'A szolgáltatásunk ára 14 500 Ft kiszállási díjból és az akku árából áll. Minden szerelés az akku bevizsgálásával kezdődik, ha nincs szükség rá, akkor természetesen nem kell megvásárolni az akkumulátort.' },
	{ h: 'Környezettudatos szerelés', p: 'A szolgáltatásunk természetes része, hogy a használt akkumulátort, mint veszélyes hulladékot, elszállítjuk és újrahasznosításáról gondoskodunk.' },
	{ h: 'Korrekt garancia', p: 'Ügyfeleinknek biztosítunk egy alkalommal ingyenes indítást Budapesten, így garancia esetén könnyű bemenni a 13. ker. Váci út 8. alatti üzletbe (H-P 9-18 ó), ahol a garanciális ügyintézés zajlik.' },
];

const REVIEWS = [
	{ img: '/img/reviews/zoli.jpg', who: 'Bathó Zoltán', text: 'Az Akku 24 segítsége életet mentett. Nagyon hamar kiérkeztek, kicserélték az akkut és igazán szakszerű és profi segítséget kaptam. Ajánlom mindenkinek.' },
	{ img: '/img/reviews/peti.jpg', who: 'Gellérfi Péter', text: 'Nagyon köszönöm a hatékony segítséget, nagyon felkészültek és gyorsak voltatok.' },
];

const TEAM = [
	{ img: '/img/team/ildi.jpg', name: 'Ildi' },
	{ img: '/img/team/andris.jpg', name: 'Andris' },
	{ img: '/img/team/tomi.jpg', name: 'Tomi' },
];

export default function HomePage() {
	return (
		<>
			<Seo
				title="Akku 24+ - Akkumulátor csere a helyszínen, Budapesten"
				description="Akku 24+ akkusegély Budapesten az év minden napján, reggel 8-tól éjfélig. Akkumulátor házhozszállítás és helyszíni csere fél-egy órán belül."
			/>

			<section className="home-video" id="video">
				<div className="container home-video__grid">
					<VideoPlayer videoId="SdrLmojOIfI" title="Akku 24+ bemutató" />
					<div className="home-video__text">
						<h1>Akkumulátor csere a helyszínen, Budapesten</h1>
						<p>Lemerült az autód akkumulátora? Hívj minket, kiszállunk, bevizsgáljuk és helyben kicseréljük az akkut – az év minden napján, reggel 8-tól éjfélig.</p>
					</div>
				</div>
			</section>

			<Gjkereso prompt="Akku választáshoz és rendeléshez válaszd ki gépjárműved típusát:" />

			<section className="home-szolgaltatas" id="szolgaltatas">
				<div className="container">
					<h2 className="block-title">Szolgáltatásunk</h2>
					<div className="szolg-grid">
						{SERVICES.map((s) => (
							<div key={s.h} className="szolg-item">
								<h3>{s.h}</h3>
								<p>{s.p}</p>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="home-csapat" id="csapat">
				<div className="container">
					<h2 className="block-title">Csapatunk</h2>
					<div className="csapat-row">
						{TEAM.map((m) => (
							<div key={m.name} className="csapat-profile">
								<img src={m.img} alt={m.name} />
								<p>{m.name}</p>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="home-velemenyek" id="velemenyek">
				<div className="container">
					<h2 className="block-title">Vélemények</h2>
					<div className="velemeny-grid">
						{REVIEWS.map((r) => (
							<div key={r.who} className="velemeny">
								<img src={r.img} alt={r.who} />
								<p>{r.text}<span className="who">{r.who}</span></p>
							</div>
						))}
					</div>
				</div>
			</section>
		</>
	);
}
